<template>
    <div
        v-html="icon"
    />
</template>
<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    required: true
  }
})

const icon = ref<unknown>('')

async function getIcon () {
  try {
    const iconsImport = import.meta.glob('assets/svg/**/**.svg', {
      query: '?raw',
      import: 'default',
      eager: false
    })
    icon.value = await iconsImport[`/assets/svg/${props.name}.svg`]()
  } catch {
    console.error(
        `[3cket icons] Icon '${props.name}' doesn't exist in 'assets/svg'`
    )
  }
}

await getIcon()

watchEffect(getIcon)
</script>
